module.exports = __webpack_public_path__ + "media/images/top/top/img_hero_sp-596f3ebbc1addf483bc892d87bde95c1.png";